<template>
  <ModalLayout icon="approve-in-circle" :title="`Approve creative?`" @close="close">
    <div class="text-review">
      You are about to approve '<strong>{{ meta?.creative?.name }}</strong
      >'. Once approved, no further changes can be made. Are you sure you want to proceed?
    </div>

    <template slot="footer">
      <el-button class="font-semibold" @click="close">{{ $t('cancel') }}</el-button>
      <el-button class="font-semibold ml-0" icon="el-icon-s-promotion" type="primary" :loading="loading" @click="approve"
        >Approve</el-button
      >
    </template>
  </ModalLayout>
</template>
<script>
import ModalLayout from '../ModalLayout.vue'
export default {
  name: 'Approve',
  components: { ModalLayout },
  props: {
    meta: {
      type: null,
      default: null,
    },
  },
  data() {
    return {
      loading: false,
    }
  },
  methods: {
    close() {
      this.$Modal.instance.isOpen = false
    },
    async approve() {
      this.loading = true
      await this.$store.dispatch('socialBoostCampaign/approveCreative', {
        creative_id: this.meta.creative.id,
      })
      this.$Modal.bus.$emit('reload:creatives')
      this.close()
      this.loading = false
    },
  },
}
</script>
